@if (isLoaded) {
  <p-scrollPanel [style]="{width: '100%', height: '860px'}" styleClass="styleClass">
    <p-card [style]="{width: '100%'}">
      <ng-template pTemplate="header">
        <div class="flex flex-wrap justify-content-between header">
          <div class="flex flex-column">
            <p>{{ connection.connectionType}}</p>
            <span>{{ connection.documento }}</span>
          </div>
          <div class="btn-container">
            <p-button class="col-12 md:col-3 sm:col-3 back-btn mr-2" label="Voltar" (onClick)="backToList()" />
            <p-button
              class="clean-revoke-btn"
              icon="pi pi-trash"
              [disabled]="connection.status !== 'Revogada'"
              [ngClass]="{ 'disabled-style': connection.status !== 'Revogada' }"
              (click)="connection.status === 'Revogada' && onRemoveTotal(connection.connectionId)"
            ></p-button>
            <p-button
              class="col-12 md:col-3 sm:col-3 remove-btn mr-2"
              icon="pi pi-link"
              [disabled]="connection.status === 'Revogada'"
              [ngClass]="{ 'disabled-style': connection.status === 'Revogada' }"
              (click)="connection.status !== 'Revogada' && deleteConnection()"
              label="Remover Conexão" />
            </div>
          </div>
          <div class="tabs-container">
            <p-tabs value="0" class="col-12">
              <p-tablist>
                <p-tab value="0">{{ 'companies-detail-component.bankAccountsTab' | transloco }}</p-tab>
              </p-tablist>
              <p-tabpanels>
                <p-tabpanel value="0">
                  @if (connection.bankAccounts.length) {
                    <div>
                      @for (acc of connection.bankAccounts; track acc) {
                        <div class="bank-account-list">
                          <p>{{ getBankName(acc.bankCode) }}</p>
                          @for (account of acc.accounts; track account) {
                            <span>
                              {{ acc.bankCode }} - {{ account.accountNumber }}-{{ account.accountDigit }} <br>
                            </span>
                          }
                        </div>
                      }
                    </div>
                  }
                  @if (!connection.bankAccounts.length) {
                    <div class="bank-account-list">
                      <p>{{ 'companies-detail-component.emptyBankAccountsMessage' | transloco }}</p>
                    </div>
                  }
                </p-tabpanel>
              </p-tabpanels>
            </p-tabs>
          </div>
        </ng-template>
      </p-card>
    </p-scrollPanel>
  } @else {
    <p-skeleton  class="mb-6" height="2rem" />
    <p-skeleton  class="mt-6" width="50%" height="8rem" />
    <p-skeleton class="mt-6" width="10%" height="4rem" />
  }

  <!-- Confirm Dialog para remoção de conexões -->
  <p-confirmDialog
    [visible]="showConfirmDialog"
    (onHide)="onCancelRemove()"
    header="{{'connection-home-component.dialog.title'|transloco}}"
    acceptIcon="pi pi-check"
    rejectIcon="pi pi-times"
    acceptButtonStyleClass="p-button-danger"
    rejectButtonStyleClass="p-button-secondary">

    <ng-template pTemplate="message">
      <div class="flex align-items-center gap-2">
        <i class="pi pi-exclamation-triangle text-warning" style="font-size: 1.2rem;"></i>
        <span>{{'connection-home-component.dialog.message'|transloco}}</span>
      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <p-button
          [label]="'connection-home-component.dialog.back'|transloco"
          (click)="onCancelRemove()"
          class="back-btn">
        </p-button>
        <p-button
          [label]="'connection-home-component.dialog.removeTotal'|transloco"
          (click)="onRemoveTotal(connection.connectionId)"
          class="edit-btn">
        </p-button>
      </div>
    </ng-template>
  </p-confirmDialog>


